const FATHA = '\u064E';
const DAMMA = '\u064F';
const KASRA = '\u0650';
const SUKUN = '\u0652';
const SHADDA = '\u0651';

function removeLastVowel(verb) {
  if (!verb) return verb;
  const chars = Array.from(verb);
  let lastLetterIdx = -1;
  
  for (let i = chars.length - 1; i >= 0; i--) {
    if (/[\u0621-\u064A]/.test(chars[i])) {
      lastLetterIdx = i;
      break;
    }
  }
  
  if (lastLetterIdx === -1) return verb;
  
  let result = '';
  for (let i = 0; i < chars.length; i++) {
    if (i === lastLetterIdx) {
      result += chars[i];
    } else if (i > lastLetterIdx && /[\u064B-\u065F]/.test(chars[i])) {
      continue;
    } else {
      result += chars[i];
    }
  }
  
  return result;
}

function replaceLastVowelWith(verb, newVowel) {
  if (!verb) return verb;
  const withoutLastVowel = removeLastVowel(verb);
  return withoutLastVowel + newVowel;
}

function getLastLetter(verb) {
  if (!verb) return null;
  const clean = verb.replace(/[\u064B-\u065F]/g, '');
  const chars = Array.from(clean);
  
  for (let i = chars.length - 1; i >= 0; i--) {
    if (/[\u0621-\u064A]/.test(chars[i])) {
      return chars[i];
    }
  }
  return null;
}

export function conjugatePastGeneric_Salim(verb3ms) {
  if (!verb3ms) return null;
  
  const form_3ms = verb3ms;
  const form_3fs = verb3ms + 'ت' + SUKUN;
  const stemSukun = replaceLastVowelWith(verb3ms, SUKUN);
  const form_3mp = replaceLastVowelWith(verb3ms, DAMMA) + 'وا';
  
  const lastLetter = getLastLetter(verb3ms);
  const isNunEnding = lastLetter === 'ن';
  const isTaEnding = lastLetter === 'ت';
  
  return {
    'أَنَا'    : isTaEnding ? removeLastVowel(verb3ms) + SHADDA + DAMMA : stemSukun + 'ت' + DAMMA,
    'أَنْتَ'   : isTaEnding ? removeLastVowel(verb3ms) + SHADDA + FATHA : stemSukun + 'ت' + FATHA,
    'أَنْتِ'   : isTaEnding ? removeLastVowel(verb3ms) + SHADDA + KASRA : stemSukun + 'ت' + KASRA,
    'هُوَ'     : form_3ms,
    'هِيَ'     : form_3fs,
    'نَحْنُ'   : isNunEnding ? removeLastVowel(verb3ms) + SHADDA + FATHA + 'ا' : stemSukun + 'ن' + FATHA + 'ا',
    'أَنْتُمْ' : isTaEnding ? removeLastVowel(verb3ms) + SHADDA + DAMMA + 'م' + SUKUN : stemSukun + 'ت' + DAMMA + 'م' + SUKUN,
    'أَنْتُنَّ': isTaEnding ? removeLastVowel(verb3ms) + SHADDA + DAMMA + 'ن' + FATHA + SHADDA : stemSukun + 'ت' + DAMMA + 'ن' + FATHA + SHADDA,
    'هُمْ'     : form_3mp,
    'هُنَّ'    : isNunEnding ? removeLastVowel(verb3ms) + SHADDA + FATHA : stemSukun + 'ن' + FATHA,
  };
}
